import { useEffect, useRef } from "react"

type Options = {
	hasNextPage: boolean
	isFetchingNextPage: boolean
	fetchNextPage(): void
}
export default function useInfiniteScroll<T extends HTMLElement = HTMLDivElement>({
	hasNextPage,
	isFetchingNextPage,
	fetchNextPage,
}: Options) {
	const sentinelRef = useRef<T>(null)

	useEffect(() => {
		const target = sentinelRef.current
		if (!target) return
		if (!hasNextPage) return

		const observer = new IntersectionObserver(
			entries => {
				const entry = entries[0]
				if (entry?.isIntersecting && !isFetchingNextPage) {
					fetchNextPage()
				}
			},
			{ rootMargin: "500px" },
		)
		observer.observe(target)

		return () => {
			observer.disconnect()
		}
	}, [hasNextPage, isFetchingNextPage, fetchNextPage])

	return sentinelRef
}
